export default __webpack_public_path__ + "static/media/check2.4ff95b1f.svg";